"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchFilter = exports.compileFilter = void 0;
const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const likeToRegex = (pattern, flags = '') => {
    let re = '';
    let i = 0;
    while (i < pattern.length) {
        const ch = pattern[i];
        if (ch === '\\' && i + 1 < pattern.length) {
            const next = pattern[i + 1];
            if (next === '%' || next === '_' || next === '\\') {
                re += escapeRegExp(next);
                i += 2;
                continue;
            }
        }
        if (ch === '%') {
            re += '.*';
        }
        else if (ch === '_') {
            re += '.';
        }
        else {
            re += escapeRegExp(ch);
        }
        i++;
    }
    return new RegExp(`^${re}$`, flags);
};
const compileLeaf = (field, op, value) => {
    switch (op) {
        case 'eq':
            return value === null
                ? (item) => item[field] == null
                : (item) => item[field] === value;
        case 'neq':
            return value === null
                ? (item) => item[field] != null
                : (item) => item[field] !== value;
        case 'in': {
            const arr = value;
            return (item) => arr.includes(item[field]);
        }
        case 'nin': {
            const arr = value;
            return (item) => !arr.includes(item[field]);
        }
        case 'like': {
            const re = likeToRegex(String(value));
            return (item) => re.test(String(item[field] ?? ''));
        }
        case 'ilike': {
            const re = likeToRegex(String(value), 'i');
            return (item) => re.test(String(item[field] ?? ''));
        }
        case 'contains': {
            const needle = String(value).toLowerCase();
            return (item) => String(item[field] ?? '').toLowerCase().includes(needle);
        }
        case 'starts_with': {
            const needle = String(value).toLowerCase();
            return (item) => String(item[field] ?? '').toLowerCase().startsWith(needle);
        }
        case 'ends_with': {
            const needle = String(value).toLowerCase();
            return (item) => String(item[field] ?? '').toLowerCase().endsWith(needle);
        }
        case 'gte':
            return (item) => item[field] >= value;
        case 'lte':
            return (item) => item[field] <= value;
        case 'gt':
            return (item) => item[field] > value;
        case 'lt':
            return (item) => item[field] < value;
        case 'is_null':
            return (item) => item[field] == null;
        case 'is_not_null':
            return (item) => item[field] != null;
        // По элементам массива; не-массив в поле — «элементов нет», условие ложно.
        case 'any_eq':
            return (item) => {
                const elems = item[field];
                return Array.isArray(elems) && elems.includes(value);
            };
        case 'any_in': {
            const arr = value;
            return (item) => {
                const elems = item[field];
                return Array.isArray(elems) && elems.some((elem) => arr.includes(elem));
            };
        }
        case 'any_contains': {
            const needle = String(value).toLowerCase();
            return (item) => {
                const elems = item[field];
                return Array.isArray(elems) && elems.some((elem) => String(elem ?? '').toLowerCase().includes(needle));
            };
        }
    }
};
/**
 * Компилирует CrudFilterAst в reusable predicate-функцию.
 * AST обходится один раз, like/ilike → RegExp компилируется один раз.
 * Результат можно вызывать многократно на разных items без повторного обхода.
 */
const compileFilter = (ast) => {
    if (ast.and !== undefined) {
        if (ast.and.length === 0)
            return () => true;
        const fns = ast.and.map(exports.compileFilter);
        return (item) => fns.every((fn) => fn(item));
    }
    if (ast.or !== undefined) {
        if (ast.or.length === 0)
            return () => false;
        const fns = ast.or.map(exports.compileFilter);
        return (item) => fns.some((fn) => fn(item));
    }
    if (ast.not !== undefined) {
        const fn = (0, exports.compileFilter)(ast.not);
        return (item) => !fn(item);
    }
    if (ast.field === undefined || ast.op === undefined) {
        throw new Error('compileFilter: node has neither composition nor leaf');
    }
    return compileLeaf(ast.field, ast.op, ast.value);
};
exports.compileFilter = compileFilter;
/**
 * One-shot convenience: компилирует AST и сразу проверяет один item.
 * Для многократных проверок использовать `compileFilter` напрямую.
 */
const matchFilter = (ast, item) => (0, exports.compileFilter)(ast)(item);
exports.matchFilter = matchFilter;
//# sourceMappingURL=filter-match.js.map